/**
 * AdminSidebar - Sidebar do painel administrativo
 *
 * Refatorado para usar BaseSidebar compartilhado
 */

import React from 'react';
import {
  LayoutDashboard,
  TrendingUp,
  Briefcase,
  Users,
  Calculator,
  CircleDollarSign,
  Megaphone,
  Bell,
  Plus,
  FolderCog,
  FileText,
  FileCheck,
  History,
  ShieldCheck,
} from 'lucide-react';
import { BaseSidebar, NavigationItem } from './BaseSidebar';
import { useAuth } from '@/contexts/AuthContext.hook';
import { getInvestmentTypeLabel } from '@/utils/investmentLabels';

interface AdminSidebarProps {
  onSidebarToggle?: (open: boolean) => void;
}

export const AdminSidebar: React.FC<AdminSidebarProps> = ({ onSidebarToggle }) => {
  const { isAdmin } = useAuth();

  const navigationItems: NavigationItem[] = [
    {
      label: 'Dashboard',
      href: '/admin/dashboard',
      icon: <LayoutDashboard className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Produtos',
      href: '/products',
      icon: <Briefcase className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Investimentos',
      href: '/admin/investments',
      icon: <TrendingUp className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: `Aportes ${getInvestmentTypeLabel('trade')}`,
      href: '/admin/aportes-trade',
      icon: <Calculator className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Aportes Private',
      href: '/admin/aportes-Private',
      icon: <Plus className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Distribuições Private',
      href: '/admin/distribuicoes-Private',
      icon: <CircleDollarSign className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Comunicados',
      href: '/admin/comunicados',
      icon: <Megaphone className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Notificações',
      href: '/admin/notificacoes',
      icon: <Bell className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Gerenciar Docs',
      href: '/admin/gerenciar-documentos',
      icon: <FolderCog className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Diligencias',
      href: '/admin/diligencias',
      icon: <FileText className="text-sidebar-foreground size-4 shrink-0" />,
    },
    ...(isAdmin
      ? [
          {
            label: 'Usuários',
            href: '/admin/users',
            icon: <Users className="text-sidebar-foreground size-4 shrink-0" />,
          },
          {
            label: 'Termos de Uso',
            href: '/admin/termos',
            icon: <FileCheck className="text-sidebar-foreground size-4 shrink-0" />,
          },
          {
            label: 'Histórico de Acesso',
            href: '/admin/historico-acessos',
            icon: <History className="text-sidebar-foreground size-4 shrink-0" />,
          },
          {
            label: 'Compliance Investidores',
            href: '/admin/compliance/investors',
            icon: <ShieldCheck className="text-sidebar-foreground size-4 shrink-0" />,
          },
        ]
      : []),
  ];

  return (
    <BaseSidebar
      navigationItems={navigationItems}
      profilePath="/admin/profile"
      onSidebarToggle={onSidebarToggle}
    />
  );
};

export default AdminSidebar;
